import { get, post } from '@/api/http'

// 获取城市
export function getCity() {
  return post('/manager/gCity/query')
}
// 获取数据字典
export function getDict(params) {
  return post('/manager/gDict/query', params)
}
// 获取金牌供应商
export function getGoldComp(params) {
  return post('/system/pcompany/queryGold', params)
}
// 获取港口
export function getPort(params) {
  return post('/manager/gPortOcean/list', params)
}
// 空港匹配查询
export function getAirPort(params) {
  return post('/manager/gPortAir/query4Like', params)
}
// 海港匹配查询
export function getOceanPort(params) {
  return post('/manager/gPortOcean/query4Like', params)
}
// 查询港口
export function getHotPort(params) {
  let action = '/manager/gPortOcean/query'
  if (params.portType === 1) {
    action = '/manager/gPortAir/query'
  }
  return post(action, params)
}
// 获取船公司匹配查询

export function getCarrier(params) {
  return post('/manager/gCarrier/query4Like', params)
}

// 查询船公司
export function searchCarrier(params) {
  return post('/manager/gCarrier/list', params)
}

// 获取全部船公司
export function getAllCarrier(params) {
  return post('/manager/gCarrier/query', params)
}

// 获取全部航空公司
export function getAllAirline(params) {
  return post('/manager/gAirline/query', params)
}
export function getAirlineList(params) {
  return post('/manager/gAirline/list', params)
}
// 获取全部航线
export function getAllLine(params) {
  return post('/manager/gLine/query', params)
}
// 获取全部行业
export function getAllNature() {
  return get('GNature_Q', {
    params: {
      blockCompCode: 1,
    },
  }).then(({ data }) => data.GNature)
}
// 获取全部行业
export function getAllIndustry() {
  return get('GIndustry_Q', {
    params: {
      blockCompCode: 1,
    },
  }).then(({ data }) => data.GIndustry)
}
// 获取节点
export function getTracking() {
  return get('GTracking_Q', {
    params: {},
  }).then(({ data }) => data.GTracking)
}
// 收发通查询
export function getPUserShipper(params) {
  return post('/system/pusershipper/query', params)
}

// 查询地点
export function getPlaceList(params) {
  return post('/manager/gPlace/list', params)
}
